var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading-bg"}},[_c('div',{staticClass:"loading-logo"},[_c('img',{attrs:{"src":require("@/assets/images/logo/logo.png"),"alt":"Logo"}})]),_c('div',{staticClass:"loading"},[_c('div',{staticClass:"effect-1 effects"}),_c('div',{staticClass:"effect-2 effects"}),_c('div',{staticClass:"effect-3 effects"})])])
}]

export { render, staticRenderFns }